import styled, { keyframes } from 'styled-components';

export const ExportButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  padding: 15px 0;
`

export const ExportButton = styled.button`
  color: rgb(255, 255, 255);
  background-color: rgb(242, 101, 34);
  border: none;
  padding: 6px 12px;
  border-radius: 8px;
  text-transform: uppercase;
  font-weight: 700;
  font-family: "DM Sans", sans-serif;
  cursor: pointer;
  :hover {
    background-color: rgb(220, 75, 34);
  }
`

const dots = keyframes`
  0% { content: '.'; }
  33% { content: '..'; }
  66% { content: '...'; }
  100% { content: ''; }
`

export const DotLoading = styled.span`
&::after {
  content: '';
  animation: ${dots} 1s steps(3, end) infinite;
  display: inline-block;
  width: 1em;
  text-align: left;
}
`